import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MdClose, MdDeveloperBoard } from 'react-icons/md';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import { useLanguage } from '../../context/LanguageContext';

export default function AddSystemModal({ companyId, onClose, onSuccess }) {
    const { t } = useLanguage();
    const [systemName, setSystemName] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!systemName.trim()) { setError(t('addSystemModal.systemRequired')); return; }

        try {
            setLoading(true);
            const res = await api.post('/systems', { companyId, systemName: systemName.trim() });
            toast.success(t('addSystemModal.systemCreated'));
            onSuccess(res.data.data);
        } catch (err) {
            const msg = err.response?.data?.message || t('addSystemModal.createFailed');
            toast.error(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <AnimatePresence>
            <motion.div
                className="modal-overlay"
                initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
                onClick={(e) => e.target === e.currentTarget && onClose()}
            >
                <motion.div
                    className="modal"
                    style={{ maxWidth: 440 }}
                    initial={{ opacity: 0, scale: 0.9, y: 30 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.9 }}
                    transition={{ duration: 0.25 }}
                >
                    <div className="modal-header">
                        <div className="modal-title">
                            <div style={{ width: 36, height: 36, borderRadius: 10, background: 'rgba(16,185,129,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--success)' }}>
                                <MdDeveloperBoard />
                            </div>
                            {t('addSystemModal.title')}
                        </div>
                        <button className="modal-close" onClick={onClose} id="close-system-modal"><MdClose /></button>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 16 }}>
                                {t('addSystemModal.description')}
                            </p>
                            <div className="form-group">
                                <label className="form-label" htmlFor="system-name">{t('addSystemModal.systemName')}</label>
                                <input
                                    id="system-name"
                                    className="form-input"
                                    type="text"
                                    placeholder={t('addSystemModal.systemNamePlaceholder')}
                                    value={systemName}
                                    onChange={(e) => { setSystemName(e.target.value); setError(''); }}
                                    disabled={loading}
                                    autoFocus
                                />
                                {error && <div className="form-error">{error}</div>}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading} id="cancel-system-btn">
                                {t('common.cancel')}
                            </button>
                            <button type="submit" className="btn btn-success" disabled={loading} id="submit-system-btn">
                                {loading ? <><span className="spinner spinner-sm" /> {t('common.creating')}</> : t('addSystemModal.createSystem')}
                            </button>
                        </div>
                    </form>
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
}
